import React, { useEffect, useState } from 'react';
import '../App.css';
//import { Navbar, Bibliote, Footer} from '../container';
import { Header_2026, Footer_2026, Biblioteca_header_recomendados_2026, Biblioteca_recomendados_2026, Biblioteca_contacto_2026 } from '../container';
import { useNavigate } from 'react-router-dom';
import Modalibro from "../components/modalLibro/ModalLibro";
import { useTranslation } from "react-i18next";
import axios from 'axios';
// import Biblioteca from '../container/biblio/biblioteca/Biblioteca';

const Recomendados = () => {
    const [t, i18n] = useTranslation("biblioteca");
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(window.location.search);
    const idiomaliga = queryParams.get("libro");
    const rut = "https://www.ricardosalinas.com/images/libros/";

    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [variable1, setVariable1] = useState("");
    const [variable2, setVariable2] = useState("");
    const [variable3, setVariable3] = useState("");
    const [variable4, setVariable4] = useState("");
    const [variable5, setVariable5] = useState("");
    const [variable6, setVariable6] = useState("");
    const [variable7, setVariable7] = useState("");
    const [variable8, setVariable8] = useState("");
    const [variable9, setVariable9] = useState("");
    const [id_idea, setId_idea] = useState(0);

    const openModal2 = (
        value1,
        value2,
        value3,
        value4,
        value5,
        value6,
        value7,
        value8,
        value9,
        valueid
    ) => {

        setVariable1(value1);
        setVariable2(value2);
        setVariable3(value3);
        setVariable4(value4);
        setVariable5(value5);
        setVariable6(value6);
        setVariable7(value7);
        setVariable8(value8);
        setVariable9(value9);
        setId_idea(valueid);
        setIsModalOpen2(true);
    };

    const closeModal2 = () => {
        setIsModalOpen2(false);
    };

    const formatDate = (date) => {
        const options = { year: "numeric" };
        return new Date(date).toLocaleDateString(i18n.language, options);
    };

    useEffect(() => {
        if (idiomaliga) {
            axios.get(`https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/library/searchbyId?id=${idiomaliga}&lang=${i18n.language}`)
                .then(response => {
                    const data = response.data[0]; // Asumiendo que siempre hay solo un elemento en el array
                    console.log(data);

                    openModal2(
                        rut + data.imagen,
                        data.imagen.substring(0, data.imagen.length - 4),
                        data.titulo,
                        data.descripcion,
                        data.autor,
                        data.editorial,
                        formatDate(data.fecha),
                        data.blog,
                        i18n.language,
                        idiomaliga
                    )
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        }
        // Dependencia vacía para que se ejecute solo una vez al montar el componente
    }, []);

    return (
        <div className="App_DB Libreria ">
            <Header_2026 />
            {/* <Biblioteca/> 
        <Bibliote/>*/}
            <div className='recomendaciones-shell'>
                <Biblioteca_header_recomendados_2026 />
                <Biblioteca_recomendados_2026 />
                <Biblioteca_contacto_2026 />
            </div>
            <Footer_2026 />

            {/* <NL_Header/>
        <NL_Adn40/>
        <NL_Video_semblanza/>
        <NL_Recomendados/>
        <NL_Descarga/> */}
            <Modalibro
                isOpen={isModalOpen2}
                closeModal={closeModal2}
                variable1={variable1} //ruta con imagen
                variable2={variable2} //titulo
                variable3={variable3} //descripcion
                variable4={variable4} //autor
                variable5={variable5} //editorial
                variable6={variable6} //año
                variable7={variable7} //año
                variable8={variable8} //año
                variable9={variable9} //año
                id_idea={id_idea}

            // hdksjfjkds
            />
        </div>
    )
}

export default Recomendados
